import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3d7f364a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7f364a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/thScoreShop/thScoreAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d7f364a')) {
      api.createRecord('3d7f364a', component.options)
    } else {
      api.reload('3d7f364a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3d7f364a&scoped=true&", function () {
      api.rerender('3d7f364a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/config/operateLog/index.vue"
export default component.exports